'use client';

import { faQuoteLeft } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Image from "next/image";

type Props = {
  sectionName: string;
};

export default function Quotation(props: Props) {
  const { sectionName } = props;

  const getSectionColor = (sectionName: string): string => {
    switch (sectionName) {
      case 'instalaciones':
        return 'bg-orange'
      case 'eventos':
        return 'bg-red'
      default:
        return 'bg-gray-400';
    }
  };

  const getTextColor = (sectionName: string): string => {
    switch (sectionName) {
      case 'instalaciones':
        return 'text-orange'
      case 'eventos':
        return 'text-red'
      default:
        return 'text-gray-400';
    }
  };


  const getImage = (sectionName: string): {
    line: string;
  } => {
    switch(sectionName) {
      case 'instalaciones':
        return {
          line: "/images/lines/orangeCirclesYellowHook.png",
        };
      case 'eventos':
        return {
          line: "/images/lines/redCirclePinkHook.png",
        };
      default:
        return {
          line: "/images/lines/orangeCirclesYellowHook.png",
        };
    }
  };
  
  return (
    <section className="bg-[#FCFBF8] relative mx-auto py-4 px-8 mt-16">
      <Image src={`${getImage(sectionName).line}`} alt="decoration" width={400} height={56} className="absolute -top-[55px] right-0 scale-x-[-1] rotate-180"/>
      <div className="flex flex-col items-center justify-center gap-4 md:flex-row">
        <div className="h-52 w-52 rounded-full overflow-hidden border-8 border-black/[0.04]">
          <Image src="/images/quotationPicture.jpg" alt="Picture" width={208} height={208} className="hidden md:block h-full w-full pt-8 md:pt-0 object-fit"/>
        </div>
        <div className="px-16 pt-8 pb-8 xl:px-0">
          <FontAwesomeIcon icon={faQuoteLeft} className={`${getTextColor(sectionName)} text-5xl`}/>
          <p className="font-thin text-center max-w-lg mb-6 py-2 md:text-start"> <span className="font-semibold">Las artes culinarias son un vehículo para reunir personas, hacer comunidad y encadenar la economía local.</span> Por esto, cuando contratamos buscamos personas que no solo sepan la técnica, sino que tengan el espíritu emprendedor necesario para comunicar las historias detrás de lo que preparan y tratar el producto local con el cuidado y amor que merecen. En Amura encontramos una excelente combinación en la formación têcnica y emprendedora de sus estudiantes.”
          </p>
          <h4 className={`${getSectionColor(sectionName)} text-center text-white text-md font-bold rounded-bl-full rounded-tr-full px-8 py-1 w-52 md:mx-0`}>César Madriz</h4>
          <p className="text-sm px-5 py-2 md:text-start">Dueño, <br/ > <span className="font-bold">Restaurante Franco</span></p>
        </div>
      </div>
    </section>
  );
}